/** Canonical static asset URLs (root-relative for SSR and base href). */
export const ASSET_PATHS = {
  brand: {
    logo: '/assets/brand/gabali-logo.png',
    favicon: '/assets/brand/favicon-32.png',
  },
  icons: {
    mapPriceMarker: '/assets/icons/map/price-marker.svg',
    compliance: {
      housingOpportunity: '/assets/icons/compliance/housing-opportunity.png',
      mls: '/assets/icons/compliance/mls.png',
    },
    partners: {
      zillowProvidedBy: '/assets/icons/partners/zillow-provided-by.jpg',
    },
  },
  images: {
    heroes: {
      homeModern: '/assets/images/heroes/home-modern.jpg',
      homeLaredoAerial: '/assets/images/heroes/home-laredo-aerial.jpg',
      homeLaredoAerialWebp800: '/assets/images/heroes/home-laredo-aerial-800.webp',
      homeLaredoAerialWebp1600: '/assets/images/heroes/home-laredo-aerial-1600.webp',
      guidesUltrawide: '/assets/images/heroes/guides-ultrawide.jpg',
      estimatePhoto: '/assets/images/heroes/estimate-photo.jpg',
      estimateBackground: '/assets/images/heroes/estimate-background.png',
    },
    pages: {
      contactUs: '/assets/images/pages/contact-us.jpg',
    },
    ui: {
      noResults: '/assets/images/ui/no-results.png',
    },
  },
  guides: {
    buyer: {
      agents: '/assets/guides/buyer/agents.jpeg',
      getPrequalified: '/assets/guides/buyer/get-prequalified.jpg',
      chooseMortgageLender: '/assets/guides/buyer/choose-mortgage-lender.jpg',
      searchForHomes: '/assets/guides/buyer/search-for-homes.jpg',
      closeOnHome: '/assets/guides/buyer/close-on-home.jpg',
    },
    seller: {
      getYourHomeReady: '/assets/guides/seller/get-your-home-ready.jpg',
      findHomeWorth: '/assets/guides/seller/find-home-worth.jpg',
      acceptTheOffer: '/assets/guides/seller/accept-the-offer.jpg',
      closeOnYourHome: '/assets/guides/seller/close-on-your-home.jpg',
    },
  },
  team: {
    elijahMarisolNora: '/assets/team/elijah-marisol-nora.png',
  },
  documents: {
    consumerProtection: '/assets/documents/consumer-protection.pdf',
    brokerageServices: '/assets/documents/brokerage-services.pdf',
  },
} as const;
